// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__X6LyN","signatureButtonsRight":"ModalSign_signatureButtonsRight__zQcv6"};